import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Coins, Gift, ChevronRight, TrendingUp } from "lucide-react";

export default function PointsWidget() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/points/me");
        setData(r.data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return null;
  const total = data?.total ?? 0;
  const recent = (data?.history || []).filter((h) => h.points > 0).slice(0, 3);

  return (
    <div
      data-testid="points-widget"
      className="bg-gradient-to-br from-[#1B2E7A] to-[#13205A] text-white rounded-md p-5 mb-10 fade-up stagger-2 overflow-hidden relative"
    >
      <div
        className="absolute -right-6 -top-6 h-32 w-32 rounded-full opacity-15"
        style={{ background: "radial-gradient(circle at center, #EAB308, transparent 60%)" }}
      />
      <div className="flex items-center justify-between gap-4 flex-wrap relative z-10">
        <div className="flex items-center gap-4">
          <div className="h-14 w-14 rounded-md bg-white/10 flex items-center justify-center">
            <Coins className="h-7 w-7 text-[#EAB308]" strokeWidth={1.5} />
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-white/60 mb-1">Mis puntos Canales</p>
            <p className="font-heading text-4xl font-medium leading-none">{total.toLocaleString("es-MX")}</p>
            {recent.length > 0 && (
              <p className="text-xs text-white/70 mt-2 inline-flex items-center gap-1">
                <TrendingUp className="h-3 w-3" /> +{recent.reduce((s, r) => s + r.points, 0)} en tu historial reciente
              </p>
            )}
          </div>
        </div>
        <Link
          to="/recompensas"
          data-testid="rewards-link"
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-[#EAB308] hover:bg-[#c08e4d] text-[#1A1A1A] text-sm font-medium transition-colors"
        >
          <Gift className="h-4 w-4" />
          Catálogo de premios
          <ChevronRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
